import { ProgressiveItems } from './ProgressiveItems';

import * as S from './styles';

interface IProgressiveDiscountProps {
  promocaoCores: string;
  regras: Array<{
    quantidade: number;
    precoUnitario: number;
    precoUnitarioTexto: string;
  }>;
  onClick(showAfterRequest: boolean, quantity?: number): void;
}

export function ProgressiveDiscount({
  promocaoCores,
  regras,
  onClick,
}: IProgressiveDiscountProps) {
  return (
    <S.Container className="progressive-discount">
      <span
        className="progressive-discount-title"
        style={{
          background: `${
            !!promocaoCores
              ? `linear-gradient(to right, ${promocaoCores})`
              : 'linear-gradient(to right, var(--green_light), var(--green_blue))'
          }`,
        }}
      >
        Desconto Progressivo
      </span>

      <span className="progressive-discount-mensagem">
        Quanto mais comprar, mais descontos vai ganhar!
      </span>

      <ProgressiveItems
        promocaoCores={promocaoCores}
        regras={regras}
        onClick={onClick}
      />
    </S.Container>
  );
}
